
import '@/mixins/extendedComponent'

import { webGL } from '@/webGL/WebGL'

// import gsap from 'gsap'

// gsap.ticker.remove(gsap.updateRoot)

export default {

  created () {
    window.addEventListener('resize', this._onResize)
    window.addEventListener('scroll', this._onScroll)
    window.addEventListener('keydown', this._onKeyDown)

    this.$device._onResize()
    this.$hub.emit('resize', event)
  },

  mounted () {
    webGL.el = this.$refs.containerWebGL
    // this.$dom3d.attachTo(this.$refs.containerCSS3D)
    // this.$dom3d.setCamera(webGL.camera)
  },

  methods: {
    onUpdate ({delta, elapsed}) {
      // gsap.updateRoot(elapsed * .001)
      // this.$dom3d.update()
    },

    _onResize (event) {
      clearTimeout(this.timer)
      // this.$dom3d.onResize(this.$device.width, this.$device.height)
      webGL.resize()
      this.timer = setTimeout(() => {
        this.$device._onResize()
        this.$hub.emit('resize', event)
      }, 200)
    },
    _onScroll (event) {
      this.$device._onScroll()
      this.$hub.emit('scroll', event)
    },
    _onKeyDown (event) {
      this.$hub.emit('keydown', event.keyCode)
      if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
        this.$hub.emit('keydown:escape', event.keyCode)
      }
    }
  }
}
